import { useLingui } from "@lingui/react/macro";
import { ArrowRightFromLineIcon } from "@offstreetparking/design-system/icons/ArrowRightFromLineIcon";
import { ChevronDownIcon } from "@offstreetparking/design-system/icons/ChevronDownIcon";
import { SettingsIcon } from "@offstreetparking/design-system/icons/SettingsIcon";
import { Menu, MenuDivider, MenuItem } from "@offstreetparking/design-system/overlay/Menu";
import { classNames } from "@offstreetparking/design-system/utils";
import { usePathname } from "next/navigation";
import { useParker } from "~/components/providers/AuthProvider";
import { useLogoutRedirect } from "~/hooks/useLogoutRedirect";
import { routes } from "~/routes";
import { TopBarUserDetails } from "./TopBarUserDetails";
export const TopBarUserDropdown = () => {
	const { t } = useLingui();
	const parkerContext = useParker();
	const pathname = usePathname();
	const logoutPath = useLogoutRedirect();
	if (!parkerContext.isLoggedIn) {
		return null;
	}
	const { parker, displayName } = parkerContext;
	const isActive = pathname === routes.account() || pathname.startsWith(`${routes.account()}/`);
	return (
		<Menu
			size="custom"
			anchor="bottom end"
			className="w-72 overflow-hidden"
			trigger={({ open }) => (
				<button
					type="button"
					className={classNames(
						"flex items-center gap-2 rounded-md px-3 py-2 font-medium text-neutral text-sm transition-colors",
						open ? "bg-neutral-faded text-primary" : "",
						isActive ? "bg-primary-faded text-primary" : "text-neutral hover:bg-neutral-faded",
					)}
					aria-label={displayName}
					aria-current={isActive ? "page" : undefined}
				>
					<span>{displayName}</span>
					<ChevronDownIcon className={classNames("h-4 w-4 transition-transform", open ? "rotate-180" : "")} />
				</button>
			)}
		>
			<TopBarUserDetails
				displayName={displayName}
				firstName={parker.firstName}
				lastName={parker.lastName}
				email={parker.email}
			/>
			<div className="px-2 pb-2">
				<MenuItem
					icon={SettingsIcon}
					label={t`Account Settings`}
					href={routes.account()}
					className="px-3 py-2 text-primary"
				/>
				<MenuDivider />
				<MenuItem
					icon={ArrowRightFromLineIcon}
					label={t`Logout`}
					href={logoutPath}
					prefetch={false}
					className="px-3 py-2 text-primary"
				/>
			</div>
		</Menu>
	);
};
